import { configureStore } from '@reduxjs/toolkit';
import { gtmMiddleware } from './Middlewares/Gtm.middleware';
import { historyMiddleware } from './Middlewares/History.middleware';
import reducers from './reducers';

export const createStore = (preloadState) => {
  return configureStore({
    preloadedState: {
      ...preloadState,
      productFiltering: {
        ...preloadState?.productFiltering,
        currentCategoryDescription: '',
      },
    },
    reducer: reducers,
    middleware: [historyMiddleware, gtmMiddleware],
  });
};

const store = createStore(global['LitiumPreloadState']);
export type AppDispatch = typeof store.dispatch;
export default store;
